/* eslint-disable @typescript-eslint/no-non-null-assertion */
import {AnyAction, CollectionFactory, Reducer} from '@modifi/redux'
import {LegalRepresentativeView, getAuthenticatedThemisClient} from '@modifi/onboarding-api-clients'
import {createSelector} from 'reselect'

const apiClient = getAuthenticatedThemisClient()

type EntityWithId = LegalRepresentativeView & {
  externalId: NonNullable<LegalRepresentativeView['externalId']>
}

const {reducer, selectors, actions} = CollectionFactory<
  Record<string, any>,
  EntityWithId,
  any,
  Record<string, never>
>({
  entityPrimaryKeySelector: entity => entity.externalId!,
  reducerPath: ['data', 'legalRepresentatives'],
  actionNamePrefix: `data/legal-representatives`,
  fetchRequest: () =>
    apiClient.LegalRepresentatives.fetch().then(
      res => (res.data()?.legalRepresentatives as EntityWithId[]) || []
    ),
})

export default reducer as Reducer

export const selectLegalRepresentatives = (state: Record<string, any>): EntityWithId[] =>
  selectors.selectByKeyWindow(state, 'all') as EntityWithId[]

export const selectLegalRepresentativesWhereLoaded = (state: Record<string, any>): boolean =>
  selectors.selectFetchCountByKeyWindow(state, 'all') > 0

export const selectLegalRepresentativesAreLoading = (state: Record<string, any>): boolean =>
  selectors.selectIsKeyWindowLoading(state, 'all')

export const selectLegalRepresentativeByExternalId = (
  state: Record<string, any>,
  externalPersonId: string
): LegalRepresentativeView | null =>
  selectors.selectById(state, externalPersonId) as LegalRepresentativeView | null

export const selectLegalRepNameByExternalId = createSelector(
  selectLegalRepresentativeByExternalId,
  legalRep => (legalRep ? `${legalRep?.firstName || ''} ${legalRep?.lastName || ''}` : '')
)

export const aFetchLegalRepresentatives = (): any => actions!.fetch('all')

export const aUpdateLocalLegalRepresentative = (
  legalRepresentative: EntityWithId,
  merge = true
): AnyAction => actions!.update(legalRepresentative, merge) as unknown as AnyAction

export const aAppendLegalRepresentativeToCompany = (entity: EntityWithId): AnyAction =>
  actions!.appendEntity?.('all', {ident: entity.externalId, entity}) as AnyAction

export const aDeleteLocalLegalRepresentative = (externalPersonId: string): AnyAction =>
  actions!.deleteEntity?.('all', externalPersonId) as AnyAction
